import { Loader2 } from "lucide-react";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useChatbotV2Flag } from "../hooks/useChatbotV2Flag";

type ChatbotAccessRouteProps = {
  children: ReactNode;
};

const ChatbotAccessRoute = ({ children }: ChatbotAccessRouteProps) => {
  const { enabled, loading } = useChatbotV2Flag();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#f5f6fa] text-sm font-medium text-gray-500">
        <Loader2 className="mr-2 h-4 w-4 animate-spin text-[#2b5ce6]" />
        Cargando Chatbot...
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default ChatbotAccessRoute;
